module.exports = __webpack_public_path__ + "img/logo-acconomy-grey.06203b92.svg";